export const EARN_REFERENCE_PREFIX = 'EARN_REF'
export const EARN_PRODUCT_PROVIDER_NAME = 'Coinbase'
